import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createBlock(_component_Swiper, {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: false,
    preventClicks: true,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 18000,
    direction: _ctx.horizontal,
    zoom: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      340: { slidesPerView: 1 },
      450: { slidesPerView: 1 },
      576: { slidesPerView: 2 },
      768: { slidesPerView: 2 },
      800: { slidesPerView: 2 },
      992: { slidesPerView: 2.5 },
      1440: { slidesPerView: 3 },
      1600: { slidesPerView: 3 },
      1881: { slidesPerView: 4 },
    },
    modules: _ctx.modules,
    class: "banner-slide-1"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.effectiveSlides, (slide, i) => {
        return (_openBlock(), _createBlock(_component_SwiperSlide, { key: i }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: slide.image,
              alt: "slide"
            }, null, 8, _hoisted_1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["direction", "modules"]))
}